import DenunciaCorrecta from './DenunciaCorrecta';

export default DenunciaCorrecta;
